const home = (state = null, action) => {
  const { payload, type } = action;
  let filtered, idsList;

  switch (type) {
    case 'INITIAL_DATA':
      if (!payload.home) return {};

      return {
        ...payload.home,
        initialPostsCount: payload.posts?.length || 0
      };

    case 'SET_HOME':
      return {
        ...payload,
        initialPostsCount: payload?.length || 0
      };

    case 'ADD_POST':
      return {
        ...state,
        posts: [payload, ...state.posts]
      };

    case 'ADD_POSTS_HOME':
      idsList = payload.map((x) => x._id);

      return {
        ...state,
        posts: [...state.posts, ...payload]
      };

    case 'REMOVE_POST':
      return {
        ...state,
        posts: state.posts.filter((post) => post._id !== payload)
      };

    case 'ADD_STORY':
      filtered = state?.stories.filter((x) => x._id !== payload._id);

      return {
        ...state,
        stories: [payload, ...(filtered || [])]
      };

    case 'FOLLOW':
      return {
        ...state,
        inspiringFans: state?.inspiringFans.map((x) => {
          if (x._id !== payload._id) return x;

          return {
            ...x,
            followersCount: x.followersCount + 1
          };
        }),
        trendingAthletes: state?.trendingAthletes.map((x) => {
          if (x._id !== payload._id) return x;

          return {
            ...x,
            followersCount: x.followersCount + 1
          };
        })
      };

    case 'FOLLOW_MULTIPLE':
      let payloadIds = payload.map((x) => x._id);

      return {
        ...state,
        inspiringFans: state.inspiringFans.map((x) => {
          if (!payload.includes(x._id)) return x;

          return {
            ...x,
            followersCount: x.followersCount + 1
          };
        }),
        trendingAthletes: state.trendingAthletes.map((x) => {
          if (!payload.includes(x._id)) return x;

          return {
            ...x,
            followersCount: x.followersCount + 1
          };
        })
      };

    case 'UPDATE_GAMES':
      return {
        ...state,
        games: state.games.map((x) => {
          const updatedGame = payload.find((y) => y._id === x._id);
          if (!updatedGame) return x;

          return {
            ...x,
            ...updatedGame
          };
        })
      };

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default home;
